import { render } from "./collection-data-table.vue?vue&type=template&id=ef1c8cf2"
import script from "./collection-data-table.vue?vue&type=script&lang=js"
export * from "./collection-data-table.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__